
export const base_url = "https://app-api.firinisan-agricultural.com/api/";
//export const base_url = process.env.REACT_APP_API_URL || "http://localhost:4000/api/";
